import axios from 'axios';
import constant from "./../services/constant";
import { getItem, logout } from 'services/utils';
import { Constants } from 'services/keyConstants';

const api = axios.create({
  baseURL: `${constant.API_URL}`,
  headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = getItem(Constants.KEY_USER_TOKEN), designationId = getItem(Constants.KEY_SELECTED_ROLE)?.roleId || "";
  if (token) config.headers.Authorization = token;
  if (designationId) config.headers.designationId = designationId;
  return config;
}, Promise.reject);

api.interceptors.response.use(
  (res) => res,
  ({ response }) => {
    const status = response?.status;
    if (status === 401) logout();
    // else if (status === 403) forbidden();
    return Promise.reject(response);
  }
);

export default api;
